import PropTypes from 'prop-types';
import React from 'react';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Theme } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

interface NkKeyValueProps {
  name: string;
  value: string;
  unit?: string;
  diff: string;
  color: string;
}

const NkKeyValue = (props: NkKeyValueProps) => {
  const styles = (_theme: Theme) =>
    createStyles({
      container: {
        backgroundImage: 'linear-gradient(180deg, #f1f1f1, #fafafa)',
        width: '180px',
        margin: '20px',
      },
      name: {
        fontFamily: 'Avenir Next Condensed',
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#44609d',
      },
      value: {
        fontSize: '36px',
        textAlign: 'center',
        fontWeight: 'bold',
        fontFamily: 'Avenir Next',
      },
      unit: {
        fontSize: '20px',
        display: 'inline-block',
        paddingLeft: '10px',
      },
      diff: {
        float: 'right',
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#d37b7b',
      },
    });

  const useStyles = makeStyles(styles);
  const classes = useStyles();
  return (
    <Card className={classes.container}>
      <CardContent>
        <Typography className={classes.name}>{props.name}</Typography>
        <Box className={classes.value} color={props.color}>
          {props.value}
          <Typography className={classes.unit}>{props.unit}</Typography>
        </Box>
        <Typography className={classes.diff}>{props.diff}</Typography>
      </CardContent>
    </Card>
  );
};

NkKeyValue.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  unit: PropTypes.string,
  diff: PropTypes.string,
  color: PropTypes.string,
};

export default React.memo(NkKeyValue);
